import { createFileRoute } from "@tanstack/react-router";
import { TeacherHistoryPage } from "@/projects/teacher/pages/HistoryPage";

export const Route = createFileRoute("/teacher/history")({
  head: () => ({ meta: [{ title: "Verification History — Teacher" }] }),
  component: TeacherHistoryPage,
});
